import styled from 'styled-components';

export const StyledFooter = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;

  &:has(> :only-child) {
    justify-content: center;
  }
`;
